<template>
  <div>
    <article
      class="vch-card"
      v-vch-tagging:productimpression="{ data: tagging.impression }"
      :data-impressions="searchPage ? stringifiedData : null"
    >
      <a
        class="vch-card__link"
        :href="link"
        tabindex="0"
        v-vch-tagging:productclick="{ data: tagging.click }"
      >
        <div class="vch-card__thumbnail vch-card__large product">
          <figure v-if="image">
            <img
              class="lazyload"
              :alt="imageAlt"
              :src="image.src"
              :data-srcset="image.srcset"
              :data-sizes="imageSizes"
            />
          </figure>
        </div>

        <h3 class="vch-card__heading mb-xxs">
          <span class="heading-md" v-html="range" />
          <span class="heading-md-em" v-html="productName" />
        </h3>
        <p class="vch-card__description mb-xs">{{ claim }}</p>
        <vch-product-card-rating
          v-if="rating.enabled"
          :rating="rating"
        ></vch-product-card-rating>
        <div v-else-if="rating.isBVEnabled" class="bvInlineRating productHeader" data-bv-show="inline_rating" :data-bv-product-id="productId"></div>        
      </a>
    </article>
    <a
      v-if="productName && buyOnlineEnable"
      :href="link"
      v-vch-tagging:productclick="{ data: tagging.click }"
      class="button -primary buy-btn buy-btn-tag mt-lg plp"
      @click="callpopupshow"
      @keydown.enter.prevent="activateBuyCta"
      @keydown.space.prevent="activateBuyCta"
    >
      {{ buyOnlineButton }}
    </a>
  </div>
</template>
<script>
export default {
  name: 'vch-card-product',
  props: {
    productName: {
      type: String,
      required: false,
    },
    tagging: {
      type: Object,
      required: false,
    },
    claim: {
      type: String,
      required: false,
    },
    range: {
      type: String,
      required: false,
    },
    rating: {
      type: Object,
      required: false,
    },
    image: {
      type: Object,
      required: false,
    },
    link: {
      type: String,
      required: false,
    },
    searchPage: {
      type: Boolean,
      default: false,
    },
    buyOnlineButton: {
      type: String,
      required: false,
    },
    imageSizes: {
      type: String,
      default:
        '(min-width: 1600px) 368px, (min-width: 1280px) 288px, (min-width: 1024px) 234px, 50vw',
    },
    buyOnlineEnable: {
      type: Boolean,
      default: false,
    },
    productId: {
      type: String,
      required: false
    }
  },
  methods:{
    callpopupshow(){
      document.cookie = "isLoggedIn=true; path=/;";   
    },
    activateBuyCta(event){
      event.currentTarget.click();
    }
  },
  computed: {
    stringifiedData() {
      return JSON.stringify(this.tagging.impression.ecommerce.impressions);
    },
    imageAlt() {
      return this.image?.altText || 'Product Image';
    },
  },
};
</script>
